import 'angular:locale/data:en-IN';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "en-IN";
